import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* global  __EMCEE_CONNECT__ */const isEmceeConnect = () => typeof __EMCEE_CONNECT__ !== 'undefined';
const navigateToProductUrl = _ref => {
  let {
    url,
    isRelativeUrl
  } = _ref;
  if (isEmceeConnect()) {
    window.AP.navigator.go('site', _objectSpread({}, isRelativeUrl ? {
      relativeUrl: url
    } : {
      absoluteUrl: url
    }));
  } else {
    window.location.href = url;
  }
};
const getLocation = callback => {
  if (isEmceeConnect()) {
    window.AP.getLocation(location => {
      callback(location);
    });
  } else {
    callback(window.location.href);
  }
};
export { getLocation, isEmceeConnect, navigateToProductUrl };